import type { HostReceiptType } from "@/lib/gql/__generated__/graphql";

/**
 * 種類で絞り込まない（全て）ときの値
 */
export const ALL_RECEIPT_TYPES = "ALL";

export type ReceiptTypeFilter = HostReceiptType | typeof ALL_RECEIPT_TYPES;

/**
 * 選んだ種類の領収書だけを残す。全てを選んでいれば全件を返す
 */
export const filterByReceiptType = <T extends { receiptType: HostReceiptType }>(
	receipts: T[],
	receiptType: ReceiptTypeFilter,
): T[] => {
	if (receiptType === ALL_RECEIPT_TYPES) {
		return receipts;
	}
	return receipts.filter((receipt) => receipt.receiptType === receiptType);
};
